module.exports = __webpack_public_path__ + "static/media/writer.d320b5c3.png";